import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { LabelM } from '@sorare/core/src/atoms/typography';

import type { RHEGrid_GameOfBaseball } from './__generated__/index.graphql';

const Root = styled.div`
  display: grid;
  gap: var(--unit);
  grid-auto-flow: column;
  grid-template-rows: repeat(3, 1fr);
`;

const Text = styled(LabelM)`
  text-align: center;
  color: var(--c-nd-600);
  font-variant-numeric: tabular-nums;
`;

type Props = { game: RHEGrid_GameOfBaseball };

export const RHEGrid = ({ game }: Props) => {
  return (
    <Root>
      <Text>R</Text>
      <Text bold color="var(--c-white)">
        {game.awayScore}
      </Text>
      <Text bold color="var(--c-white)">
        {game.homeScore}
      </Text>
      <Text>H</Text>
      <Text bold color="var(--c-white)">
        {game.awayHits}
      </Text>
      <Text bold color="var(--c-white)">
        {game.homeHits}
      </Text>
      <Text>E</Text>
      <Text bold color="var(--c-white)">
        {game.awayErrors}
      </Text>
      <Text bold color="var(--c-white)">
        {game.homeErrors}
      </Text>
    </Root>
  );
};

RHEGrid.fragments = {
  GameOfBaseball: gql`
    fragment RHEGrid_GameOfBaseball on GameOfBaseball {
      id
      homeHits
      homeErrors
      awayErrors
      homeScore
      awayScore
      awayHits
    }
  ` as TypedDocumentNode<RHEGrid_GameOfBaseball>,
};
